export const DESIGN_LAYOUT_TOOLBAR = {
  LAYOUT_TITLE: { key: 'LAYOUT_TITLE', value: 'Layout' },
  IN_PIXELS_DROPDOWN_OPTION: { key: 'IN_PIXELS_DROPDOWN_OPTION', value: 'In Pixels' },
  WIDTH_LABEL: { key: 'WIDTH_LABEL', value: 'Width' },
  HEIGHT_LABEL: { key: 'HEIGHT_LABEL', value: 'Height' },
  FROM_LEFT_LABEL: { key: 'FROM_LEFT_LABEL', value: 'From Left' },
  FROM_TOP_LABEL: { key: 'FROM_TOP_LABEL', value: 'From Top' },
  ROTATE_LABEL: { key: 'ROTATE_LABEL', value: 'Rotate' },
  IN_DEG_LABEL: { key: 'IN_DEG_LABEL', value: 'In deg' },
  LEFT_LABEL: { key: 'LEFT_LABEL', value: 'Left' },
  TOP_LABEL: { key: 'TOP_LABEL', value: 'Top' },
};
